export enum FormPago {
  PERSONA_QUE_PAGA = 'personaQuePaga',
  DATOS_OTRA_PERSONA = 'datosOtraPersona',
  DATOS_TARJETA_DE_CREDITO = 'datosTarjetaDeCredito',
  NOMBRES = 'nombres',
  APELLIDOS = 'apellidos',
  TIPO_DOCUMENTO = 'tipoDocumento',
  NUMERO_DOCUMENTO = 'numeroDocumento',
  CORREO = 'correo',
  CIUDAD = 'ciudad',
  TELEFONO = 'telefono',
  DIRECCION = 'direccion',
  RAZON_SOCIAL = 'razonSocial',
  NUMERO_DE_TARJETA = 'numeroDeTarjeta',
  CODIGO_DE_SEGURIDAD = 'codigoDeSeguridad',
  EXPIRATION_MONTH = 'expirationMonth',
  EXPIRATION_YEAR = 'expirationYear',
  CANTIDAD_DE_CUOTAS = 'cantidadDeCuotas',
  HABILITAR_RENOVACION_AUTOMATICA = 'habilitarRenovacionAutomatica',
}
